





























































































import { Component, Vue } from 'vue-property-decorator';
import { ApplicationListController, ConsultController } from '@/services/request.service';
import SiblingsDetail from '@/components/SiblingsDetail.vue';
import StudentDetail from '@/components/StudentDetail.vue';
import ActivityInfo from '@/components/ActivityInfo.vue';

import UniformDetail from '@/components/UniformDetail.vue';
import ApplicantDetail from '@/components/ApplicantDetail.vue';
import EmergencyDetail from '@/components/EmergencyDetail.vue';
import BankInfoDetail from '@/components/BankInfoDetail.vue';
import ParentDetail from '@/components/ParentDetail.vue';
import FormRemark from '@/components/FormRemark.vue';
import FileUploadList from './FileUploadList.vue';
import config from '@/school.config';
import { getSchoolInfo } from '@/utils/utils';

@Component({
  components: {
    SiblingsDetail,
    StudentDetail,
    ApplicantDetail,
    EmergencyDetail,
    BankInfoDetail,
    UniformDetail,
    ParentDetail,
    FormRemark,
    FileUploadList,
    ActivityInfo,
  },
})
export default class CommonDetail extends Vue {
  public tabKey: string = 'studentInfo'; // studentInfo | parentsInfor
  public studentInfo: any = {};
  public parentInfo: any = {};
  public siblings: any = {};
  public emergencyContactResponse: any = {};
  public guardianResponse: any = {};
  public studentId: number = 0;
  public fileList: Array<any> = [];
  public config = config;
  public consultData: any = [];
  public isShowSchool: boolean = false;
  public detail: boolean = true;
  public get locale(): string {
    return this.$i18n.locale;
  }

  public created(): any {
    this.studentId = this.$route.query.studentId ? Number(this.$route.query.studentId) : 0;
    this.getApplicationById();
    this.getFileList();
    this.getConsultList();
  }

  public get school() {
    return getSchoolInfo().shortName;
  }
  public getConsultList() {
    const id = this.studentId;
    ConsultController.getConsultList(Number(id)).then((res: any) => {
      this.consultData = res.data;
    });
  }

  public getApplicationById(): void {
    const id = this.$route.query.studentId;
    this.config[this.school].controller.getApplicationById(Number(id)).then((res: any) => {
      this.formatData(res);
    });
  }

  public getFileList(): void {
    ApplicationListController.getApplicationListDetailList(this.studentId).then(res => {
      this.fileList = res.data;
    });
  }

  public formatData(res: any): void {
    this.studentInfo = res.data;
    if (res.data.followStatus === '1907' || res.data.followStatus === '1910') {
      this.parentInfo = res.data.basicParents;
      this.isShowSchool = true;
    } else {
      this.parentInfo = res.data.parentInfo;
      this.isShowSchool = false;
    }
    // this.parentInfo = res.data.parentInfo;
    this.siblings = res.data.siblings;
    this.guardianResponse = this.parentInfo.guardianResponse ? this.parentInfo.guardianResponse : {};
    this.emergencyContactResponse = this.parentInfo.emergencyContactResponse
      ? this.parentInfo.emergencyContactResponse
      : {};
    this.parentInfo.emergencyContactFlag = this.parentInfo.emergencyContactResponse ? false : true;
  }

  public changeTabKey(type: string): void {
    this.tabKey = type;
  }
}
